// import { CheckedIcon } from '@/components/address-selector';
import FlexBox from '@/atomic-components/FlexBox';
import { LencoImage } from '@/atomic-components/Image';
import LencoButton from '@/atomic-components/LencoButton';
import { VAS_TYPES, ICartItem } from '@/services/cart/models/cart';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box, Divider } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { useState } from 'react';
import { DSelectedItemsForParticularVasType } from '../CartVasCustomizationPopup';
import VasApplicableCartItem from '../VasApplicableCartItem';
import WhatsCoveredInVasDrawer from '../WhatsCoveredInVasDrawer';
import CareProgramVasOutlined from '@/assets/vas/CareProgramVasOutlined.svg';

type VasCustomizationProductListProps = {
	items: ICartItem[];
	vasType: VAS_TYPES;
	selectItem: (item: ICartItem) => void;
	selectedItemsForSelectedVasType: DSelectedItemsForParticularVasType;
};

const vasLabels = {
	FURLENCO_CARE_PROGRAM: 'Furlenco Care',
	FLEXI_CANCELLATION: 'Flexi Cancellation',
};

const vasIcons = {
	FURLENCO_CARE_PROGRAM: <CareProgramVasOutlined />,
	FLEXI_CANCELLATION: <CareProgramVasOutlined />,
};

const VasCustomizationProductList = (
	props: VasCustomizationProductListProps
) => {
	const [isAdditionalInfoDrawerVisible, setIsAdditionalInfoDrawerVisible] =
		useState<boolean>(false);
	const additionalInfo =
		props.items[0]?.valueAddedServices[props.vasType]?.additionalInfo;

	function displayAdditionalInfo() {
		setIsAdditionalInfoDrawerVisible(true);
	}

	function hideAdditionalInfo() {
		setIsAdditionalInfoDrawerVisible(false);
	}

	return (
		<>
			<WhatsCoveredInVasDrawer
				title={
					<FlexBox alignItems={'center'} mb='14px'>
						{vasIcons[props.vasType]}
						<LencoTypography
							sx={{
								...getStyle('H11A_Medium'),
								color: getColor('Gray 0'),
							}}
							ml='12px'
						>
							{vasLabels[props.vasType]}
						</LencoTypography>
					</FlexBox>
				}
				htmlContent={additionalInfo?.description}
				isVisible={isAdditionalInfoDrawerVisible}
				onClose={hideAdditionalInfo}
				drawerContainerSx={{ p: '54px 40px' }}
			/>
			<FlexBox
				direction='column'
				alignItems='start'
				sx={{ backgroundColor: '#FFFFFF' }}
			>
				{additionalInfo?.label && (
					<FlexBox alignItems='start' mt='20px'>
						<LencoButton variant='text' onClick={displayAdditionalInfo}>
							{additionalInfo?.label}
						</LencoButton>
					</FlexBox>
				)}
				<FlexBox
					direction='column'
					alignItems='flex-start'
					sx={{ width: '100%' }}
				>
					{props?.items?.map((item, index) => {
						const selectedVasDetailsOfItem =
							item?.valueAddedServices[props.vasType];

						if (!selectedVasDetailsOfItem) return null;

						const price = selectedVasDetailsOfItem?.price?.displayValue;

						const isSelected =
							!!props.selectedItemsForSelectedVasType![props.vasType] &&
							!!props.selectedItemsForSelectedVasType![props.vasType][item.id];

						const isLast = index < props.items.length - 1;

						return (
							<Box sx={{ width: '100%' }} key={item.product.name}>
								<VasApplicableCartItem
									isSelected={isSelected}
									item={item}
									price={price}
									onAddClicked={props.selectItem}
								/>
								{isLast && <Divider sx={{ width: '100%' }} />}
							</Box>
						);
					})}
				</FlexBox>
			</FlexBox>
		</>
	);
};

export default VasCustomizationProductList;
